// src/pages/DeleteAccount.js
import React from 'react';
import {
  Container,
  Typography,
  Link,
  Divider,
  List,
  ListItem,
  Alert,
} from '@mui/material';

const LAST_UPDATED = '02 Ekim 2025';
const APP_NAME = 'Süzme Sayaç';
const CONTACT_EMAIL = 'info@suzmesayac.com';

export default function DeleteAccountPage() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* Başlık ve meta */}
      <Typography variant="h4" gutterBottom>Hesap Silme</Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Son güncelleme: {LAST_UPDATED}
      </Typography>

      <Typography paragraph>
        Bu sayfa, <strong>{APP_NAME}</strong> için hesap silme adımlarını ve silinen/saklanabilecek veri
        kategorilerini açıklar. Uygulama içinden <strong>Hesabım &gt; Hesap Bilgilerim &gt; Hesabımı Sil</strong> adımını izleyerek
        işlemi başlatabilirsiniz.
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Adımlar */}
      <Typography variant="h6" gutterBottom>Hesap Nasıl Silinir?</Typography>
      <List dense>
        <ListItem disableGutters>• Uygulamayı açın ve giriş yapın (anonim veya oturum açılmış hesap).</ListItem>
        <ListItem disableGutters>• <strong>Hesabım &gt; Hesap Bilgilerim &gt; Hesabımı Sil</strong> menüsüne gidin.</ListItem>
        <ListItem disableGutters>• Bilgilendirmeyi okuyup onay verin.</ListItem>
      </List>

      <Divider sx={{ my: 3 }} />

      {/* Kısmi veri silme */}
      <Typography variant="h6" gutterBottom>Kısmi Veri Silme</Typography>
      <Typography paragraph>
        Hesabınızı kapatmadan da belirli verilerinizi silebilirsiniz. Bu işlemler uygulama içinden
        ilgili ekranlarda yapılabilir:
      </Typography>
      <List dense>
        <ListItem disableGutters>• Faturalar ve paylaştırma kayıtları</ListItem>
        <ListItem disableGutters>• Süzme sayaçlar</ListItem>
        <ListItem disableGutters>• Sayaç okuma kayıtları</ListItem>
      </List>
      <Typography paragraph>
        <strong>Ana sayaç bilgisi yalnızca güncellenebilir, tamamen silinemez.</strong>
      </Typography>
      <Typography paragraph>
        Alternatif olarak, kısmi veri silme taleplerinizi{' '}
        <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link> adresine iletebilirsiniz.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Silinen ve saklanabilecek veriler */}
      <Typography variant="h6" gutterBottom>Silinen Veriler</Typography>
      <List dense>
        <ListItem disableGutters>• Kimlik bilgileri (ad, e-posta; sosyal girişlerde sağlayıcı kimlikleri dahil)</ListItem>
        <ListItem disableGutters>• Ana sayaç, süzme sayaçlar, sayaç okumaları, faturalar ve paylaştırma kayıtları</ListItem>
        <ListItem disableGutters>• Uygulama içi tercih ve ayarlar</ListItem>
      </List>

      <Typography variant="h6" gutterBottom>Saklanmaya Devam Edebilecek Veriler ve Süreler</Typography>
      <List dense>
        <ListItem disableGutters>
          • Abonelik/ödeme kayıtları: Mağaza sağlayıcıları (Apple App Store / Google Play) ve RevenueCat sistemlerinde
          muhasebe/uyumluluk gereği saklanan zorunlu işlem kayıtları.
        </ListItem>
        <ListItem disableGutters>
          • Sunucu logları ve yasal yükümlülükler: Güvenlik ve mevzuat gereği sınırlı süreyle saklanabilir
          (azami 90 gün; yasal zorunluluk daha uzun süre gerektirmedikçe).
        </ListItem>
      </List>

      <Divider sx={{ my: 3 }} />

      {/* İletişim */}
      <Typography variant="h6" gutterBottom>İletişim</Typography>
      <Typography paragraph>
        Tüm sorular için <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link> adresine yazabilirsiniz.
      </Typography>

      <Alert severity="warning" variant="outlined">
        <strong>Not:</strong> Hesabın silinmesi kalıcıdır ve geri alınamaz. Silme tamamlandığında {APP_NAME} verilerinize
        erişemezsiniz.
      </Alert>
    </Container>
  );
}
